import React, { Component } from "react";

export default class SuccessAlert extends Component {
  render() {
    return (
      <div>
        <div class="alert alert-success alert-dismissible card card-info">
          <h4>{this.props.message}</h4>
        </div>
      </div>
    );
  }
}
